import { Base } from "@/atoms-react/text/Text.react";
import { DevicePhoneMobileIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import type React from "react";
import { twMerge } from "tailwind-merge";
import { AliasCard } from "../alias-card/index.react";
import { useTranslation } from "react-i18next";
import Flag from "@/atoms-react/flag/Flag.react";
import { PHONE_COUNTRY_CODES } from "@/features/utils/constants";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { AliasMobileSchema } from "@/types/user/alias-mobile.types";

type PhoneCardProps = {
  aliasMobile: AliasMobileSchema;
  onClick?: () => void;
  onPublicClick?: () => void;
  onDelete?: () => void;
  onDeleteHelper?: string;
  disabled?: boolean;
} & Omit<React.ComponentPropsWithoutRef<"div">, "onClick">;

export const PhoneCardV2 = ({
  aliasMobile,
  onPublicClick,
  disabled = false,
  ...props
}: PhoneCardProps) => {
  const { t } = useTranslation(["pass"]);
  const countryFromMobileCode = _.invert(PHONE_COUNTRY_CODES)[aliasMobile.mobileCode ?? ""] ?? "";

  return (
    <AliasCard
      tooltipDesignation={t("olkypass.aliasPublicPage.this_phone_number")}
      isPublic={aliasMobile.public}
      isMain={aliasMobile.main}
      icon={DevicePhoneMobileIcon}
      onPublicClick={onPublicClick}
      disabled={disabled}
      {...props}
    >
      {aliasMobile.main && (
        <div
          className={twMerge(
            "flex overflow-hidden text-ellipsis whitespace-nowrap break-normal font-semibold"
          )}
        >
          {t("aliasMobilePage.main.title")}
          <div data-tooltip={t("aliasMobilePage.main.description")} data-position="bottom">
            <InformationCircleIcon className={`mr-1 h-4 w-4`} />
          </div>
          {":"}
        </div>
      )}

      <div className="flex items-center gap-2">
        <div className={"flex gap-2"}>
          <Flag countryCode={countryFromMobileCode} className="!w-6 !h-6 rounded-sm" />
          <Base>{aliasMobile.mobileCode}</Base>
        </div>
        <Base className={twMerge("overflow-hidden whitespace-nowrap break-normal")}>
          {aliasMobile.phoneNumber}
        </Base>
      </div>
    </AliasCard>
  );
};
